<template>
  <div class="memory">
    <TabBar_m />
    <div class="banner"></div>
    <div class="memory_txt">
      <div class="title">
        <h6>memorabilia</h6>
        <i></i>
        <h3>大事记</h3>
      </div>

      <div class="memory_con">
        <div class="memory_2020">
          <div class="dot">
            <span>2020</span>
            <i></i>
          </div>
          <ul class="memory_item_txt">
            <li>
              <span class="mouth">3月</span>
              <span>
                迭代销售大神APP，加入新功能-虚拟
                电话。
              </span>
            </li>
            <li>
              <span class="mouth">6月</span>
              <span>
                销售大神企业入驻超百万，用户超50
                万。
              </span>
            </li>
          </ul>
        </div>

        <div class="memory_2019">
          <ul class="memory_item_txt">
            <li>
              <span class="mouth">3月</span>
              <span>
                陕西远达智能科技有限公司推出了第
                二款产品-销售大神APP，帮助解决销
                售难题。
              </span>
            </li>
            <li>
              <span class="mouth">6月</span>
              <span>
                陕西远达智能科技有限公司官网上线
                了。
              </span>
            </li>
          </ul>
          <div class="dot">
            <span>2019</span>
            <i></i>
          </div>
        </div>

        <div class="memory_2018">
          <div class="dot">
            <span>2019</span>
            <i></i>
          </div>
          <ul class="memory_item_txt">
            <li>
              <span class="mouth">6月</span>
              <span>陕西远达智能科技有限公司成立了。</span>
            </li>
            <li>
              <span class="mouth">7月</span>
              <span>
                陕西远达智能科技有限公司官网上线
                了。
              </span>
            </li>
            <li>
              <span class="mouth">9月</span>
              <span>
                陕西远达智能科技有限公司推出了第
                一款产品-万物物联APP。
              </span>
            </li>
            <li>
              <span class="mouth">12月</span>
              <span>
                万物物联APP的客户破百，用户超10
                万。
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <Footer_m />
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="less" scoped>
.banner {
  background: url("../../assets/image_m/brief_bgc.png") no-repeat;
  background-position: center;
  background-size: 100%;
  margin-top: 50px;
  &::before {
    content: "";
    padding-top: 100%;
    display: block;
  }
}
.memory_txt {
  .title {
    padding: 16px;
    h6 {
      line-height: 15px;
      font-size: 10px;
      text-transform: uppercase;
    }
    i {
      display: block;
      width: 30px;
      height: 2px;
      background: #26acff;
      margin: 4px 0;
    }
    h3 {
      line-height: 25px;
      font-size: 18px;
      margin-bottom: 12px;
    }
    p {
      text-indent: 2em;
      line-height: 21px;
      font-size: 15px;
    }
  }
  .memory_con {
    background: url("../../assets/image_m/memory_bg.png") no-repeat;
    background-position: top;
    background-size: 100% 73%;
    height: 800px;
    position: relative;

    .memory_2020 {
      position: absolute;
      left: 10%;
      top: 8%;
      display: flex;
    }
    .dot {
      margin-right: 20px;
      i {
        display: block;
        width: 10px;
        height: 10px;
        background: #26acff;
        border-radius: 50%;
      }
    }

    .memory_item_txt {
      background: #ffffff;
      border: 1px solid #eaeaea;
      padding: 12px;
      span {
        font-size: 12px;
      }
      .mouth {
        line-height: 31px;
        color: #26acff;
      }
    }
    .memory_2019 {
      position: absolute;
      right: 3%;
      top: 29%;
      display: flex;
      .dot {
        margin-left: 50px;
      }
    }
    .memory_2018 {
      display: flex;
      position: absolute;
      top: 63%;
      left: 10%;
    }
  }
}
@media (min-width: 320px) and (max-width: 500px) {
  .memory_txt {
    .memory_con {
      .memory_2019 {
        right: -3%;
      }
    }
  }
}
@media (min-width: 500px) and (max-width: 980px) {
  .memory_txt {
    .memory_con {
      .memory_2019 {
        right: 1%;
      }
    }
  }
}
</style>